import { useState } from "react";
import {
  Box,
  // Button,
  CircularProgress,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { AxiosResponse } from "axios";
import { Form, Formik, FormikValues } from "formik";
import * as yup from "yup";

import http from "../../utils/http";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import {
  AuthLayout,
  // FormHelperTextContainer,
  SignInWrapper,
} from "./auth.style";
import { StyledButton } from "../Common/styles/button";
import { InputWrapper, LabelStyle } from "../Common/styles/form";
import isEmail from "validator/es/lib/isEmail";
import { useTranslation } from "react-i18next";

const schema = yup.object({
  email: yup
    .string()
    .required("FORGOT_PASSWORD_PAGE.VALIDATION_EMAIL_REQUIRED")
    .test(
      "is-valid",
      "FORGOT_PASSWORD_PAGE.VALIDATION_EMAIL_INVALID",
      (value) => (value ? isEmail(value) : false)
    ),
});

const ForgotPassword = () => {
  const { t } = useTranslation("auth");
  const [submitLoader, setSubmitLoader] = useState(false);

  // const navigate = useNavigate();

  const submitHandler = async (values: any) => {
    try {
      setSubmitLoader(true);
      let data = {
        username: values.email,
        strategy: "email",
      };
      const url = "/user/auth/forgot-password";
      const res: AxiosResponse = await http.post(url, data);
      setSubmitLoader(false);
      toastMessage("success", res.data.message);
    } catch (err) {
      errorToastMessage(err as Error);
      setSubmitLoader(false);
    }
  };

  return (
    <Box sx={AuthLayout}>
      <Box sx={SignInWrapper}>
        <Typography variant="h2" mb={3}>
          {t("FORGOT_PASSWORD_PAGE.TITLE")}
        </Typography>

        <Typography
          variant="subtitle1"
          fontWeight={500}
          color="text.secondary"
          mb={2}
        >
          {t("FORGOT_PASSWORD_PAGE.DESCRIPTION")}
        </Typography>

        <Formik
          initialValues={{
            email: "",
          }}
          enableReinitialize
          onSubmit={(data: FormikValues) => {
            submitHandler(data);
          }}
          validationSchema={schema}
        >
          {({ values, errors, touched, getFieldProps }) => {
            return (
              <Form>
                <FormControl sx={InputWrapper}>
                  <FormLabel sx={LabelStyle} htmlFor="email">
                    {t("FORGOT_PASSWORD_PAGE.EMAIL_LABEL")}
                  </FormLabel>
                  <TextField
                    placeholder={t("FORGOT_PASSWORD_PAGE.EMAIL_PLACEHOLDER")}
                    id="email"
                    error={touched?.email && errors?.email ? true : false}
                    helperText={
                      touched?.email && errors?.email
                        ? t(errors?.email as string)
                        : " "
                    }
                    {...getFieldProps("email")}
                  />
                </FormControl>
                <Box mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                  {!submitLoader ? (
                    <StyledButton type="submit" variant="contained" fullWidth>
                      {t("SUBMIT", { ns: "common" })}
                    </StyledButton>
                  ) : (
                    <CircularProgress size={25} />
                  )}
                </Box>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
